module.exports = __webpack_public_path__ + "img/na.16d27b05.svg";